import {atom} from 'jotai';

export interface SessionLimitInfo {
  limitedBy: 'session' | 'day';
  resetsAt: Date;
  /** The blocked screen — used to auto-resume its queued message at reset. */
  flowId: string;
  screenId: string;
}

/** Set when a generation is blocked by a session limit (server 429). */
export const sessionLimitAtom = atom<SessionLimitInfo | null>(null);

/**
 * Block known client-side and still running. Only for adjusting feedback
 * (e.g. optimistic toasts) — the server gate stays authoritative.
 */
export function isActiveSessionLimit(
  info: SessionLimitInfo | null,
): info is SessionLimitInfo {
  return info !== null && info.resetsAt > new Date();
}
